var map = {
	"./Hyphen.png": 62577,
	"./Hyu.png": 4772,
	"./Lifespan.png": 85095,
	"./Renee.png": 17914,
	"./Snitch.png": 97401,
	"./Swiss Beauty.png": 47683,
	"./WeRize.png": 41436,
	"./adidas.png": 27610,
	"./amazon.png": 39894,
	"./beato.png": 44946,
	"./bella-vita.png": 50362,
	"./boat.png": 66370,
	"./boldcare.png": 53838,
	"./bombay-shaving-company.png": 36751,
	"./booking-com.png": 80998,
	"./cadbury.png": 66119,
	"./clove-oral-care.png": 73249,
	"./croma.png": 68882,
	"./dot-and-key.png": 26820,
	"./fab-india.png": 35173,
	"./firstcry.png": 70920,
	"./fitspire.png": 27484,
	"./flipkart.png": 54999,
	"./forest-essentials-india.png": 65797,
	"./foxtale.png": 35006,
	"./giva.png": 37325,
	"./go-noise.png": 62496,
	"./kama-ayurveda.png": 24770,
	"./kama.png": 36535,
	"./kindlife.png": 28196,
	"./koparo-clean.png": 37394,
	"./libas.png": 34539,
	"./mamaearth.png": 25198,
	"./max-protein.png": 21164,
	"./mcaffeine.png": 76810,
	"./medibuddy.png": 67925,
	"./minimalist.png": 80690,
	"./muscleblaze.png": 67126,
	"./neeman.png": 13977,
	"./nykaa.png": 46184,
	"./pattern.png": 89050,
	"./plum-goodness.png": 24991,
	"./puer.png": 33138,
	"./puma.png": 49962,
	"./shopsy.png": 24122,
	"./shyaway.png": 7211,
	"./smytten.png": 84348,
	"./sova-health.png": 95734,
	"./ssbeauty.png": 41795,
	"./the-derma-co.png": 44902,
	"./the-man-company.png": 23355,
	"./times-prime.png": 13723,
	"./truemeds.png": 77939,
	"./weryze.png": 19414,
	"./world-of-asaya.png": 34919,
	"./wow.png": 5449,
	"./xyxx-crew.png": 8656,
	"./zandu-care.png": 66329
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 33503;